import * as React from 'react';
import { useAppSelector } from '../../hooks';
import { currentLayoutSelector, useRecomputeLayout } from './layoutSlice';
import { Cytoscape } from './Cytoscape';
import { Popup } from './Popup';
import './Graph.css';
import { useDispatch } from 'react-redux';
import { elementsSelectedSelector, setSelectedElements } from './selectionSlice';
export function Graph() {
    // Trigger starting the async layout computation, when this node is rendered
    useRecomputeLayout();
    const cytoscape = React.useMemo(() => React.createElement(Cytoscape, null), []);
    return (React.createElement("div", { className: "graph" },
        React.createElement(UnselectElements, null),
        React.createElement(Overlay, null),
        React.createElement(Popup, null),
        cytoscape));
}
function UnselectElements() {
    const dispatch = useDispatch();
    const elementsSelected = useAppSelector(elementsSelectedSelector);
    return (React.createElement("button", { className: "unselect-elements", onClick: () => dispatch(setSelectedElements(null)), disabled: !elementsSelected }, "Unselect elements"));
}
function Overlay() {
    const layout = useAppSelector(currentLayoutSelector);
    if (layout === null) {
        return React.createElement("div", { className: "overlay center-text" }, "No active dataflow runtime");
    }
    switch (layout.type) {
        case 'loading':
            return React.createElement("div", { className: "overlay center-text" }, "Laying out graph...");
        case 'done':
            return React.createElement(React.Fragment, null);
        case 'error':
            return (React.createElement("div", { className: "overlay" },
                React.createElement("h2", null, "Encountered an error running ELK layout:"),
                React.createElement("pre", null, layout.error.stack)));
    }
}
